import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import img1 from "../../../../assets/img/Services/ProductEngineering/15.png"
import { FaCompass, FaDesktop, FaPaintBrush, FaUserAlt } from "react-icons/fa"
import {AiOutlineSafety} from "react-icons/ai"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Edge Computing Solutions
            </h1>
            <p className="text-lg text-gray-600">
            Deploy edge-based systems for real-time processing and low-latency decision-making.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaDesktop className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Edge Device Scalability</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Deploy scalable edge devices to handle increasing workloads without cloud dependency.

              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineSafety className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Enhanced Security and Privacy
                </h3>         
              </div>
              <p className="text-gray-600 text-sm">
              Process sensitive data locally to minimize exposure to external threats.
              </p>
            </div>

            {/* Feature 3 */}
            {/* <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaPaintBrush className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Aesthetic Appeal</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Create visually appealing interfaces that align with brand identity.
              </p>
            </div> */}

          </div>
        </div>

      
      </div>
    </div>
  )
}